// extracted by mini-css-extract-plugin
export default {"tableRef":"UsersList_tableRef__3k9tA","columnTitle":"UsersList_columnTitle__Gea8w","flexEnd":"UsersList_flexEnd__VxzRo"};